<template>
	<q-modal
		v-model="show_modal"
		:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '75vh' }"
		no-backdrop-dismiss
		no-esc-dismiss
	>
		<q-modal-layout>
			<q-toolbar slot="header">
				<q-btn flat round dense @click="show_modal = false" icon="fas fa-times" />
				<q-toolbar-title>
					{{ $t('cancellation_requests') }}
				</q-toolbar-title>
			</q-toolbar>

			<div class="layout-padding">
				<q-tabs animated v-model="tab" color="secondary" class="shadow-1">
					<q-tab
						slot="title"
						name="awaiting_approval"
						icon="fal fa-hourglass-half"
						:label="$t('awaiting_approval')"
					/>
					<q-tab
						slot="title"
						name="cancellation_approved"
						icon="fal fa-calendar-check"
						:label="$t('enrollment_canceled')"
					/>
					<q-tab
						slot="title"
						name="cancellation_reproved"
						icon="fal fa-times-square"
						:label="$t('cancellation_reproved')"
					/>

					<q-tab-pane name="awaiting_approval" class="q-px-lg q-pb-xl" keep-alive>
						<awaiting-approval
							:load="
								tab === 'awaiting_approval' && show_enrollment_modal ? true : false
							"
							@change_tab="changeTab"
							:is_admin="is_admin"
						/>
					</q-tab-pane>

					<q-tab-pane name="cancellation_approved" class="q-px-lg q-pb-xl" keep-alive>
						<cancellation-approved
							:load="
								tab === 'cancellation_approved' && show_enrollment_modal
									? true
									: false
							"
						/>
					</q-tab-pane>

					<q-tab-pane name="cancellation_reproved" class="q-px-lg q-pb-xl" keep-alive>
						<cancellation-reproved
							:load="
								tab === 'cancellation_reproved' && show_enrollment_modal
									? true
									: false
							"
						/>
					</q-tab-pane>
				</q-tabs>
			</div>
		</q-modal-layout>
	</q-modal>
</template>

<script>
import AwaitingApproval from 'components/admin/planned_vacancies/AwaitingApproval'
import CancellationApproved from 'components/admin/planned_vacancies/CancellationApproved'
import CancellationReproved from 'components/admin/planned_vacancies/CancellationReproved'

import { mapGetters } from 'vuex'
import { date } from 'quasar'

export default {
	name: 'AdminPresentialEnrollmentCancellation',

	props: ['show_enrollment_modal'],

	components: {
		'awaiting-approval': AwaitingApproval,
		'cancellation-approved': CancellationApproved,
		'cancellation-reproved': CancellationReproved,
	},

	data() {
		return {
			tab: 'awaiting_approval',
			observation: '',
			attachments_view: false,
			attachments_to_view: null,
			attachments: [],
			has_logs: false,
			logs: [],
			is_admin: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			user_clients: 'common/user_clients',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		show_modal: {
			get() {
				return this.show_enrollment_modal
			},
			set() {
				this.$emit('hide_enrollment_modal', '')
				this.tab = 'awaiting_approval'
			},
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '70vw'
		},
	},

	methods: {
		checkUserIsAdmin() {
			let obj = this.user_clients.find((obj) => obj.id === this.id_user_client_selected)
			if (obj) {
				let userProfile = obj.client_profiles.find((profile) => profile.is_user_profile)
				if (userProfile) this.is_admin = userProfile.is_admin
			} else this.is_admin = false
		},

		changeTab(tab) {
			this.tab = tab
		},
	},

	mounted() {
		this.checkUserIsAdmin()
	},
}
</script>

<style></style>
